"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ori-ui/icons");
var _constants = require("../constants");
var _jsxRuntime = require("react/jsx-runtime");
const styleOverrides = {
  iconFilled: {
    color: _constants.colors.defaultColors.dark
  },
  iconEmpty: {
    color: _constants.colors.oriGrey[200]
  }
};
const defaultProps = {
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.FavouriteFilled, {
    fontSize: "inherit"
  }),
  emptyIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.FavouriteFilled, {
    fontSize: "inherit"
  })
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
